import { render } from "./Unavailable.vue?vue&type=template&id=205177e6"
const script = {}

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__